<template>
<div class="c-o-company-header">
  <h1 class="c-o-company-header__title">{{ company.Name }}</h1>
    <div class="c-o-company-header__inner">
        <div class="c-o-company-header__block c-o-company-header__block--info">
            <div class="c-o-company-header__details">
                <ul class="c-o-company-header__details-list">
                    <li class="c-o-company-header__details-item">
                        <div class="c-o-company-header__details-item__rating" @click="scrollToRating">
                            <rating :ratingValue="company.Rating" :nrOfRatings="company.NrOfRatings"></rating>
                        </div>
                    </li>

                    <li v-if="phoneNumber" class="c-o-company-header__details-item">
                        <div class="c-o-company-header__details-contact">
                          <p>Telefon:</p>
                          <a :href="`tel:${phoneNumber}`">{{phoneNumber}}</a>
                        </div>
                    </li>
                    
                    <li v-if="emailAdress" class="c-o-company-header__details-item">
                      <div class="c-o-company-header__details-contact">
                        <p>E-post:</p>
                        <a :href="`mailto:${emailAdress}`">{{emailAdress}}</a>
                      </div>
                    </li>

                </ul>
            </div>
            <div class="c-o-company-header__button">
                <request-button v-if="isQueued" v-tooltip.top-center="'Du har redan valt hantverkaren till din förfrågan'" :icon="'list_add'" class="c-a-button--theme-primary " :disabled="true" :label="'Välj till förfrågan'">
                </request-button>
                <request-button v-else-if="queueAtMaximum" v-tooltip.top-center="'Du kan inte välja fler hantverkare till förfrågan'" :icon="'list_add'" class="c-a-button--theme-primary " :disabled="true" :label="'Välj till förfrågan'">
                </request-button>
                <request-button v-tooltip.top-center="'Välj hantverkare till förfrågan'" :icon="'list_add'" class="c-a-button--theme-primary " :label="'Välj till förfrågan'" @buttonClicked="queueCompany(...[company])" v-else>
                </request-button>
            </div>
        </div>

        <div class="c-o-company-header__block c-o-company-header__block--image">
            <div class="c-o-company-header__inner c-o-company-header__inner--image">
                <div class="c-o-company-header__image">
                    <img v-if="company.Image" :src="company.Image" :alt="`Bild av företag ${company.Name}`"/>
                    <img v-else :src="'/assets/images/presentation-default.jpg'" alt="Bild på bygghjälmar">
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import {
    ADD_TO_QUEUE,
    GET_COMPANIES,
} from './../../../../store/store-models/queued-companies-model';


import Filters from '../../../../filters/index.js'

import Rating from '../../atoms/AtomRating.vue';
import RequestButton from '../../atoms/AtomButton.vue';
import StatusPill from '../../atoms/AtomStatus.vue';
import ButtonGroup from '../../molecules/MoleculeButtonGroup.vue';
import AtomButton from '../../atoms/AtomButtonLink.vue';
import AtomIcon from '../../atoms/AtomIcon.vue';


import {
    EventBus
} from '../../../../main';

export default {
    props: [
        'company'
    ],
    components: {
        Rating,
        RequestButton,
        StatusPill,
        ButtonGroup,
        AtomButton,
        AtomIcon
    },
    filters: Filters,
    computed: {
        ...mapGetters({
            queuedCompanies: GET_COMPANIES
        }),
        backgroundStyle: function() {
            if (this.company) {
                return `background-image: url(${this.company.Image ? this.company.Image : '/assets/images/presentation-default.jpg'});`;
            }
            return '';
        },
        isQueued: function() {
            let matches = this.queuedCompanies.filter(c => c.Id === this.company.Id);

            return matches.length > 0 ? true : false
        },
        queueAtMaximum: function() {
            return this.queuedCompanies.length >= 6 ? true : false
        },
        evaluationDate: function() {
            return this.company.Quality.EvaluationDate;
        },
        phoneNumber: function(){
          return this.company.Phone;
        },
        emailAdress: function(){
          return this.company.Email;
        }
    },
    methods: {
        ...mapActions({
            addToQueue: ADD_TO_QUEUE,
        }),
        queueCompany(company) {
            this.addToQueue(company);

            EventBus.$emit('displayQueuedCompanies');
        },
        scrollToRating: function() {
            const scrollPos = document.getElementById('ratings').offsetTop;
            window.scrollTo({
                top: scrollPos - document.getElementById('company-menu').offsetHeight,
                behavior: 'smooth'
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/company-sections/OrganismCompanyHeader.vue